import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AdminService } from 'src/app/services/admin/admin.service';
import { EMPTY, catchError, switchMap, tap } from 'rxjs';

let isRefreshing = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.url.includes('/assets/') ||
    req.url.includes('/auth/refresh') ||
    req.url.includes('/show/app/languages')
  ) {
    return next(req); // next არის HttpHandlerFn ფუნქცია
  }

  const token = localStorage.getItem('@mlUser');
  const tokenService = inject(AdminService);

  function isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp < currentTime;
    } catch {
      return true;
    }
  }

  const proceedWithRequest = (authToken: string | null) => {
    let authReq = req;
    if (authToken && req.url.startsWith('https://menuload.com/api')) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }

    // აქ უბრალოდ next(authReq) იხმარე, არ არის .handle
    return next(authReq).pipe(
      catchError((error) => {
        throw error;
      })
    );
  };

  if (token && isTokenExpired(token)) {
    if (isRefreshing) {
      return EMPTY;
    }

    isRefreshing = true;

    return tokenService.refreshToken().pipe(
      tap(() => (isRefreshing = false)),
      switchMap((data) => {
        const newToken = data.access_token || data.token;

        if (newToken) {
          localStorage.setItem('@mlUser', newToken);
          return proceedWithRequest(newToken);
        }

        return proceedWithRequest(null);
      }),
      catchError((err) => {
        isRefreshing = false;
        localStorage.removeItem('@mlUser');
        return proceedWithRequest(null);
      })
    );
  }

  return proceedWithRequest(token);
};